import React from 'react';
import { Box, Container, Divider, Grid } from '@drivekyte/web-components';
import WPTypography from '@/components/typography';
import { useMedia } from '@drivekyte/ui';
import { useTranslationAsObject } from '@/hooks/use-translation';
import InfoItem, { InfoItemProps } from './components/info-item/info-item';
import useDcsFlag from '@/hooks/use-dcs-flag';
import DcsFlags from '@/types/dcs-flags';

type HowItWorksProps = {
  heading?: string;
  sections?: Array<InfoItemProps>;
  serviceAreaCode?: string;
};

const HowItWorks = ({
  heading,
  sections,
  serviceAreaCode,
}: HowItWorksProps) => {
  const { t } = useTranslationAsObject('components.growth.how-it-works');

  const media = useMedia();
  const isMobile = media.xs;

  const { isFlagEnabled } = useDcsFlag<{}>({
    flag: DcsFlags.FreeUnlimitedMileage,
    params: {
      service_area: serviceAreaCode,
    },
  });

  return (
    <Container>
      <Box marginBottom="xLarge" paddingTop="large" width="100%">
        <WPTypography
          variant="h2"
          color="primary"
          fontFamily="Gilroy"
          fontSize="28"
          lineHeight={32}
          fontWeight={700}
          textAlign="center"
        >
          {heading || t('heading')}
        </WPTypography>
      </Box>
      {!isMobile && (
        <Box marginBottom="xxLarge">
          <Divider />
        </Box>
      )}
      <Grid container direction="row" spacing={10}>
        {(
          sections ||
          t('sections', {
            whereAndWhenInterpolation: isFlagEnabled
              ? 'with unlimited miles to roam '
              : '',
          })
        ).map((section: InfoItemProps, idx: number) => (
          <Grid item key={section.icon} md={4} xs={12}>
            <InfoItem
              icon={section.icon}
              title={section.title}
              text={section.text}
              index={idx}
            />
          </Grid>
        ))}
      </Grid>
      {isMobile && <Divider />}
    </Container>
  );
};

export default HowItWorks;
